import styles from '../../pages/chat/Chat.module.css';
import { VerifiedAnimation } from '../../assets/verified';


const Verified = () => {
  return (
    <div className={styles.loadingOverlay}>
      <div className={styles.loadingIcon}>{VerifiedAnimation}</div>
    </div>
  );
};

export default Verified;